import React, { useRef, useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { FaPhoneAlt } from "react-icons/fa";
import "../../assets/css/Navbar.css";

import emailjs from "@emailjs/browser";

function Navbar() {
  const [searchQuery, setSearchQuery] = useState("");
  const navbarCollapseRef = useRef(null);
  const navbarRef = useRef(null); // ✅ ADD navbar height measure பண்ண
  const navigate = useNavigate();
  const [toggelShow, setToggelShow] = useState(false);
  const [mobileSubOpen, setMobileSubOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [showFormModel, setShowFormModel] = useState(false);

  // Email Send
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_1l6tarq", // EmailJS service id
        "template_pgbv6sl", // EmailJS template id
        formRef.current,
        "YVQ5H8UeZgOlMDTgO", // EmailJS public key
      )
      .then(
        (result) => {
          // alert("Message sent successfully!");
          setShowFormModel(true);
          handleClose();
        },
        (error) => {
          alert("Failed to send message");
        },
      );
  };

  useEffect(() => {
    if (showFormModel) {
      const timer = setTimeout(() => {
        setShowFormModel(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showFormModel]);

  // ✅ ONLY CHANGE scroll ஆனா body padding dynamic ஆ set பண்ணும்
  useEffect(() => {
    const handleScroll = () => {
      const sticky = window.scrollY > 0;
      setIsSticky(sticky);

      if (sticky && navbarRef.current) {
        document.body.style.paddingTop = navbarRef.current.offsetHeight + "px";
      } else {
        document.body.style.paddingTop = "0px";
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.body.style.paddingTop = "0px";
    };
  }, []);

  function toggleopenclose() {
    if (navbarCollapseRef.current) {
      if (toggelShow) {
        navbarCollapseRef.current.classList.remove("show");
      } else {
        navbarCollapseRef.current.classList.add("show");
      }
      setToggelShow(!toggelShow);
    }
  }

  const closeNavbar = () => {
    if (navbarCollapseRef.current.classList.contains("show")) {
      navbarCollapseRef.current.classList.remove("show");
    }
    setMobileSubOpen(false);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      if (searchQuery) {
        window.find(searchQuery);
      }
    }, 1000);
  };

  const [searchIcon, setSearchIcon] = useState(false);
  function handeleSearch() {
    setSearchIcon(!searchIcon);
  }
  const handleSearchChange = (e) => setSearchQuery(e.target.value);

  const [triggerSearch, setTriggerSearch] = useState(false);
  useEffect(() => {
    if (triggerSearch) {
      eee();
      setTriggerSearch(false);
    }
  }, [triggerSearch]);

  const [searchResults, setSearchResults] = useState({});

  const searchAcrossRoutes = async () => {
    const routes = [
      "/about",
      "/mitsubishi",
      "/siemens",
      "/equipment-repair",
      "/contact",
      "/career",
      "/automotive-tyre",
      "/cement",
      "/machine-retrofit",
      "/",
    ];
    const results = {};
    for (const route of routes) {
      navigate(route);
      setLoading(true);
      await new Promise((r) => setTimeout(r, 1000));
      const found = window.find(searchQuery);
      if (found) {
        setTriggerSearch(true);
        results[route] = true;
        setLoading(false);
        break;
      } else {
        results[route] = false;
        setLoading(false);
      }
    }
    setSearchResults(results);
  };

  const handleKeyDown = async (e) => {
    if (e.key === "Enter") {
      if (!window.find(searchQuery)) {
        await searchAcrossRoutes();
        for (const [route, found] of Object.entries(searchResults)) {
          if (found) {
            navigate(route);
            setTriggerSearch(true);
            return;
          }
        }
      }
    }
  };

  const eee = () => {
    window.find(searchQuery);
  };

  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   handleClose();
  // };

  return (
    <div>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/SH Logo.png")}
              alt="Loading"
            />
          </div>
        </div>
      )}

      {/* Topbar */}
      <div className="container-fluid bg-dark px-0">
        <div className="row g-0 d-none d-lg-flex">
          <div className="col-lg-6 ps-5 text-start">
            <div className="h-100 d-inline-flex align-items-center text-white">
              <a
                className="btn btn-link text-light"
                href="#"
                aria-label="Facebook"
              >
                <img
                  className="logos_size"
                  alt=""
                  src={require("../../assets/img/facebook_logo.png")}
                />
              </a>
              <a
                className="btn btn-link text-light"
                href="#"
                aria-label="Youtube"
              >
                <img
                  className="logos_size"
                  alt=""
                  src={require("../../assets/img/youtube_logo.png")}
                />
              </a>
              <a
                className="btn btn-link text-light"
                href="#"
                aria-label="LinkedIn"
              >
                <img
                  className="logos_size"
                  alt=""
                  src={require("../../assets/img/linkedin_logo.png")}
                />
              </a>
              <a
                className="btn btn-link text-light"
                href="#"
                aria-label="Instagram"
              >
                <img
                  className="logos_size"
                  alt=""
                  src={require("../../assets/img/instagram_logo.png")}
                />
              </a>
              <a
                className="btn btn-link text-light"
                href="#"
                aria-label="Whatsapp"
              >
                <img
                  className="logos_size"
                  alt=""
                  src={require("../../assets/img/whatsapp_logo.png")}
                />
              </a>
            </div>
          </div>
          <div className="col-lg-6 text-end">
            <div className="h-100 topbar-right d-inline-flex align-items-center text-white py-2 px-5">
              <span className="me-2">
                <FaPhoneAlt className="me-2" />
                Call Us:
              </span>
              <span>+91-824 801 0909</span>
            </div>
          </div>
        </div>
      </div>

      <nav
        ref={navbarRef}
        className={`navbar navbar-expand-lg nav-sticky-top ${isSticky ? "navbar-fixed " : ""}`}
      >
        <div className="row toggel_bottom">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-6 col-md-5 d-flex">
                <div>
                  <NavLink to="/" exact className="navbar-brand">
                    <img
                      src={require("../../assets/img/SH 07.png")}
                      alt="Logo"
                      className="text-white toggel_img"
                    />
                  </NavLink>
                </div>
                <div className="">
                  <button
                    onClick={toggleopenclose}
                    className="navbar-toggler toggel_button"
                    type="button"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon toggel_icon"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="collapse navbar-collapse"
          id="navbarCollapse"
          ref={navbarCollapseRef}
        >
          <div className="navbar-nav ms-auto p-4 p-lg-0">
            <NavLink
              to="/"
              id="new-dropdown-name"
              className="nav-item nav-link"
              activeClassName="active"
              onClick={closeNavbar}
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              className="nav-item nav-link"
              activeClassName="active"
              onClick={closeNavbar}
            >
              About
            </NavLink>

            {/* ── SERVICE DROPDOWN ── */}
            <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Service
              </a>
              <div className="dropdown-menu dropDown_Menu m-0 p-3">
                {/* <div className="has-sub-dropdown">
                  <div className="sub-dropdown-trigger d-flex justify-content-between align-items-center">
                    <NavLink className="sub-trigger-link">
                      Industrial Automation
                    </NavLink>
                    <span
                      className={
                        "sub-arrow" + (mobileSubOpen ? " sub-arrow-open" : "")
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setMobileSubOpen(!mobileSubOpen);
                      }}
                    >
                      &#8250;
                    </span>
                  </div>
                  <div
                    className={
                      "sub-dropdown-menu dropDown_Menu mx-1 bg-light " +
                      (mobileSubOpen ? " sub-dropdown-mobile-open" : "")
                    }
                  >
                    <NavLink to="/retrofit" className="dropdown-item" activeClassName="active" onClick={closeNavbar}>Retrofit</NavLink>
                    <NavLink to="/robotic-solutions" className="dropdown-item" activeClassName="active" onClick={closeNavbar}>Robotic Solutions</NavLink>
                    <NavLink to="/product-support" className="dropdown-item" activeClassName="active" onClick={closeNavbar}>Product Support</NavLink>
                    <NavLink to="/programming" className="dropdown-item" activeClassName="active" onClick={closeNavbar}>Programming</NavLink>
                    <NavLink to="/panel-fabrication" className="dropdown-item" activeClassName="active" onClick={closeNavbar}>Panel Fabrication</NavLink>
                    <NavLink to="/iiot-software-integration" className="dropdown-item" activeClassName="active" onClick={closeNavbar}>IIOT &amp; Software Integration</NavLink>
                    <NavLink to="/programmable-logic-controller" className="dropdown-item" activeClassName="active" onClick={closeNavbar}>Programmable Logic Controller (PLCs)</NavLink>
                    <NavLink to="/training-and-support-services" className="dropdown-item" activeClassName="active" onClick={closeNavbar}>Training and Support Services</NavLink>
                  </div>
                </div> */}
                <NavLink
                  to="/industrial-automation"
                  className="dropdown-item"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Industrial Automation
                </NavLink>
                <NavLink
                  to="/embadded-system"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Embadded System
                </NavLink>
                <NavLink
                  to="/digital-marketing"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Digital Marketing
                </NavLink>
                <NavLink
                  to="/it-software"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  IT &amp; Softwares
                </NavLink>
              </div>
            </div>
            {/* ── END SERVICE ── */}

            {/* Courses */}
            <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Courses
              </a>
              <div className="dropdown-menu dropDown_Menu bg-light m-0 p-3">
                <NavLink
                  to="/our-course"
                  className="dropdown-item"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Our Course
                </NavLink>
                <NavLink
                  to="/internship"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Internship
                </NavLink>
                <NavLink
                  to="/workshops"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Workshop
                </NavLink>
                <NavLink
                  to="/seminars"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Seminar
                </NavLink>
                <NavLink
                  to="/corporatetrainings"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Corporate Trainings
                </NavLink>
              </div>
            </div>

            <NavLink
              to="/career"
              className="nav-item nav-link"
              activeClassName="active"
              onClick={closeNavbar}
            >
              Career
            </NavLink>
            <NavLink
              to="/contact"
              className="nav-item nav-link"
              activeClassName="active"
              onClick={closeNavbar}
            >
              Contact
            </NavLink>
          </div>

          {/* Search */}
          {/* <div className="mobile-view d-none d-lg-block">
            <input
              type="search"
              className={`${searchIcon ? "search-style" : "d-none"} form-control rounded`}
              placeholder="Search"
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyDown={handleKeyDown}
            />
            <button
              type="button"
              onClick={handeleSearch}
              className="btn btn-outline-danger border-0 mx-3"
            >
              <i className="fa-solid fa-magnifying-glass searchbtn"></i>
            </button>
          </div> */}

          <div className="mobile-view">
            <button
              className="btn px-3  me-5 button-color"
              style={{ width: "147px" }}
              onClick={() => {
                handleShow();
                closeNavbar();
              }}
            >
              Get A Quote
            </button>
          </div>
        </div>
      </nav>

      {/* Modal */}
      {/* <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="custom-modal"
      >
        <Modal.Header closeButton className="custom-modal-header">
          <Modal.Title className="text-white">GET A QUOTE</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-secondary fs-6 text-center mb-3">
            Please fill out this form, and we will notify you. Our team will
            contact you shortly!
          </p>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Control type="text" placeholder="Name" required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control type="tel" placeholder="Mobile" required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control type="email" placeholder="Email" required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Select required>
                <option value="">Select your need</option>
                <option value="Industrial Automation Service">
                  Industrial Automation Service
                </option>
                <option value="IT / Software Solution">
                  IT / Software Solution
                </option>
                <option value="Digital Marketing Service">
                  Digital Marketing Service
                </option>
                <option value="Certification Course">
                  Certification Course
                </option>
                <option value="Internship / Project">
                  Internship / Project
                </option>
                <option value="Corporate Training">Corporate Training</option>
                <option value="Seminar / Workshop">Seminar / Workshop</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                placeholder="Message"
                rows={3}
                required
              />
            </Form.Group>
            <div className="text-center">
              <Button className="btn text-white" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal> */}

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="custom-modal"
      >
        <Modal.Header closeButton className="custom-modal-header">
          <Modal.Title className="text-white">GET A QUOTE</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="text-secondary fs-6 text-center mb-3">
            Please fill out this form, and we will notify you. Our team will
            contact you shortly!
          </p>

          <Form ref={formRef} onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                name="user_name"
                placeholder="Name"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="tel"
                name="user_mobile"
                placeholder="Mobile"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="email"
                name="user_email"
                placeholder="Email"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Select name="user_need" required>
                <option value="">Select your need</option>

                <option value="Industrial Automation Service">
                  Industrial Automation Service
                </option>

                <option value="IT / Software Solution">
                  IT / Software Solution
                </option>

                <option value="Digital Marketing Service">
                  Digital Marketing Service
                </option>

                <option value="Certification Course">
                  Certification Course
                </option>

                <option value="Internship / Project">
                  Internship / Project
                </option>

                <option value="Corporate Training">Corporate Training</option>

                <option value="Seminar / Workshop">Seminar / Workshop</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                name="message"
                placeholder="Message"
                rows={3}
                required
              />
            </Form.Group>

            <div className="text-center">
              <Button className="btn text-white" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Success popup Model */}
      {showFormModel === true && (
        <>
          <Modal
            show={showFormModel}
            onHide={() => setShowFormModel(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Success</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
              <h5 className="text-red">Message Sent Successfully</h5>
              <p>Thank you for contacting us. We will get back to you soon.</p>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowFormModel(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </div>
  );
}

export default Navbar;
